import { ReactNode } from "react";
import "./FormSectionTitle.css";

interface FormSectionTitleProps {
  title: string | ReactNode;
}

const FormSectionTitle: React.FC<FormSectionTitleProps> = ({ title }) => {
  return <h2 className="form-section-title">{title}</h2>;
};

export default FormSectionTitle;
